module.exports = __webpack_public_path__ + "static/media/icon_in_green_circle.3ab80046.svg";